import { WIDGET_CARD_TYPE_WARNING } from '@/views/Dashboard/WidgetCard.vue';

const WIDGET_CARD_IMG_CO_BRANDED = 'window_with_glob';
const WIDGET_CARD_IMG_RECOMMENDED_TRAINING = 'e_learnings';
const WIDGET_CARD_IMG_ACH = 'hand_with_bag_of_dollars';
const WIDGET_CARD_IMG_W9 = 'task_list';
const WIDGET_CARD_IMG_REFER = 'dollar_cup';
const WIDGET_CARD_IMG_MARKETING_MATERIALS = 'hand_with_ticket';
const WIDGET_CARD_IMG_PAYMENT_INFO = 'payment_cards';

const widgetCardData = {
  coBrandedPage: {
    1: {
      priority: 1,
      widgetType: WIDGET_CARD_TYPE_WARNING,
      iconName: WIDGET_CARD_IMG_CO_BRANDED,
      title: 'Co-branded page',
      warning: {
        title: 'Action Required:',
        text: {
          customer: 'Please create your page to start offering financing',
          partner: 'Please create your page to start earning rewards',
        },
      },
      actionButton: {
        width: 219,
        text: 'CREATE PAGE NOW',
      },
      to: { name: 'co-branded' },
    },
    2: {
      priority: 11,
      iconName: WIDGET_CARD_IMG_CO_BRANDED,
      title: 'Co-branded page',
      text: 'Click the buttons below to copy URL or manage the page: customize its appearance and financing offers settings.',
      subtitleLink: {
        subtitle: 'URL: ',
        link: 'https://www.figma.com/design/yPvuCalPRGUrIqZNBmxt4U/Control-Panel?node-id=2798-1521&node-type=canvas&t=PDmiFB9FITwfnAB6-0',
      },
      copyLinkButton: {
        links: [
          // example
          // {
          //   name: 'link',
          //   value: 'https://www.google.com/',
          // },
        ],
      },
      actionButton: {
        width: 180,
        text: 'MANAGE PAGE',
      },
      to: { name: 'co-branded' },
    },
    3: {
      priority: 7,
      iconName: WIDGET_CARD_IMG_CO_BRANDED,
      title: 'Co-branded page',
      stat: {
        title: 'Number of applicants',
        helpText: 'In the last 2 years',
        items: [],
        getItems: (data) => [
          {
            number: data.submittedApplications,
            text: 'Application(s) submitted',
          },
          {
            number: data.receivedOffers,
            text: 'Offer(s) received',
          },
          {
            number: data.fundingOffers,
            text: 'Funding(s) received',
          },
        ],
      },
      copyLinkButton: {
        links: [
          // example
          // {
          //   name: 'link',
          //   value: 'https://www.google.com/',
          // },
        ],
      },
      actionButton: {
        width: 180,
        text: 'SEE DETAILS',
      },
      to: {
        name: 'reports-applications',
        params: {
          currentPeriod: 'Custom',
          customStart: null,
          customEnd: null,
        },
      },
    },
    loading: {
      priority: 11,
      iconName: WIDGET_CARD_IMG_CO_BRANDED,
      title: 'Co-branded page',
      isLoading: true,
    },
  },
  recommendedTraining: {
    1: {
      priority: 8,
      iconName: WIDGET_CARD_IMG_RECOMMENDED_TRAINING,
      title: 'Recommended Training',
      articles: [
        'Learn and improve your skills with Enhancify!',
        'We created our contractor training program to help you adopt Enhancify into your business.',
      ],
      actionButton: {
        text: 'WATCH VIDEO',
      },
      to: { name: 'training-and-faqs' },
    },
  },
  ach: {
    1: {
      priority: 5,
      iconName: WIDGET_CARD_IMG_ACH,
      title: 'ACH Info Missing',
      warning: {
        textBold: false,
        text: 'Please submit ACH form. Your payouts will be held by Enhancify until the Direct Deposit info is added.',
      },
      actionButton: {
        text: 'ADD DIRECT DEPOSIT INFO',
      },
      to: {
        name: 'payout-tax',
        params: {
          action: 'ach',
        },
      },
    },
  },
  w9: {
    1: {
      priority: 6,
      iconName: WIDGET_CARD_IMG_W9,
      title: 'W9 Form Missing',
      text: '\n\nYour payouts will be held by Enhancify until the required tax form is completed.',
      actionButton: {
        text: 'SUBMIT',
      },
      to: {
        name: 'payout-tax',
        params: {
          action: 'w9',
        },
      },
    },
  },
  refer: {
    1: {
      priority: 10,
      iconName: WIDGET_CARD_IMG_REFER,
      title: 'Get <b style="font-weight: 900;">$200</b> for a Friend',
      subtitle: 'Earn unlimited referral commission',
      text: 'Want to earn freebies and make money with referral link? Here\'s how to get started referring your friends to referral program.',
      actionButton: {
        text: 'REFER A FRIEND',
      },
      to: { name: 'refer' },
    },
  },
  marketingMaterials: {
    1: {
      priority: 9,
      iconName: WIDGET_CARD_IMG_MARKETING_MATERIALS,
      title: 'Marketing Materials',
      bullets: [
        'Flyer',
        'Social Media Images',
        'Monthly Payment Calculator',
        'Banners, Widgets',
        'Invoice And Others',
      ],
      actionButton: {
        text: 'TRY IT NOW',
      },
      to: { name: 'banners' },
    },
  },
  payment: {
    1: {
      priority: 2,
      iconName: WIDGET_CARD_IMG_PAYMENT_INFO,
      title: 'Add Payment Info',
      text: '\n\nAdd a card to pay for Enhancify.',
      actionButton: {
        text: 'ADD CARD',
      },
      to: {
        name: 'card-payments',
        params: {
          action: 'add-card',
        },
      },
    },
    2: {
      priority: 3,
      iconName: WIDGET_CARD_IMG_PAYMENT_INFO,
      title: 'Payment Card Alert',
      text: 'Please update your payment info in order not to lose access to the service.',
      getExpireText: (days, number) => `<b>In&nbsp;<span style="color:#68BA62;">${days} days</span>&nbsp;your payment card ${number} will expire.</b>`,
      actionButton: {
        text: 'UPDATE CARD',
      },
      to: {
        name: 'card-payments',
        params: {
          action: 'update-card',
        },
      },
    },
    3: {
      priority: 4,
      widgetType: WIDGET_CARD_TYPE_WARNING,
      iconName: WIDGET_CARD_IMG_PAYMENT_INFO,
      title: 'Payment Card Alert',
      warning: {
        border: false,
        getTitle: (number) => `Your payment card ${number} has expired.`,
        text: 'Please update your payment info in order not to lose access to the service.',
        textBold: false,
      },
      actionButton: {
        text: 'UPDATE CARD',
      },
      to: {
        name: 'card-payments',
        params: {
          action: 'update-card',
        },
      },
    },
  },
};

export default widgetCardData;
